<form [formGroup]="form">
    <div class="flex column align-start justify-space-between">
        <mat-form-field appearance="fill">
            <mat-label>Search</mat-label>
            <input matInput formControlName="search" />
        </mat-form-field>
        <frog-user-picker formControlName="users" label="Created By"></frog-user-picker>
        <frog-tag-picker formControlName="tags"></frog-tag-picker>
        <mat-form-field appearance="fill">
            <mat-label>Enter a date range</mat-label>
            <mat-date-range-input [rangePicker]="picker">
                <input matStartDate formControlName="startDate" placeholder="Start date" />
                <input matEndDate formControlName="endDate" placeholder="End date" />
            </mat-date-range-input>
            <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
    </div>
</form>
